import { useState } from "react";

import TableFirmSettings from "../common/table-firm-settings";
import HintModal from "../common/hint-modal";

import useGetTopUp from "./hooks/useTopUp";

const TopUp = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];

  const { data } = useGetTopUp();
  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  function formatDate(dateString) {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", options).format(date).replace(", ", ", ");
  }

  return (
    <>
      <div className="tab-pane fade firm-settings-user-perms-fs active show">
        <div className="d-flex justify-content-between m-b-5">
          <h2 className="fw-bold">Top Up</h2>
          <div
            onClick={() => {
              handleHintToggle();
            }}
          >
            <i className="ic ic-19 ic-help-2 cursor-pointer" />
          </div>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <b>Balance: </b>${data?.balance}
        </div>
        <h3 style={{ marginBottom: "10px" }}>Top-Up History</h3>
        <TableFirmSettings>
          <thead>
            <tr id="tb-header">
              <th className="text-center">Credit</th>
              <th className="text-center">Debit</th>
              <th className="text-center">Balance</th>
              <th className="text-center">Description</th>
              <th className="text-center">Date</th>
            </tr>
          </thead>
          <tbody>
            {data?.top_up_history?.map((item) => (
              <tr style={{ height: "35px" }} key={item.id}>
                <td className="color-grey">{item.credit}</td>
                <td>{item.debit}</td>
                <td>{item.balance}</td>
                <td>{item.description}</td>
                <td>{formatDate(item.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </TableFirmSettings>
      </div>
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </>
  );
};

export default TopUp;
